# ------------------------------------*|
# #Editor Layout -> block scroll
# ------------------------------------*|


moduleBlockOverlays = angular.module 'services.layoutEditor.blockDragScroll', [
  "services.editorNamespace"
]

moduleBlockOverlays.factory 'blockDragScroll', ["$timeout", "$injector", "ns", "$interval", ($timeout, $injector, ns, $interval) ->

  Y = undefined

  $window = $(window)

  blockDragScroll =
    init: (y) ->
      Y = y
      @calculate_dimensions()
    calculate_dimensions: ->
      @window_height = $window.height()
      @window_width  = $window.width()
    capitalize: (str) ->
      str.charAt(0).toUpperCase() + str.slice(1)
    clearInterval: (interval) ->
      $interval.cancel interval
    scroll: (t) ->
      e = @
      $window = $(window)
      windowHeight = $(window).height()
      stopArea = 50
      scrollArea = 70
      i = 1
      margin = 5
      processScroll = false
      pageY = angular.copy t.target.mouseXY[1]
      pageY = pageY - $window.scrollTop()
      if pageY <= scrollArea
        processScroll = true
        e.stopScroll()
        e.intTopHandler = setInterval ->
          $window.scrollTop($window.scrollTop() - margin)
          $window.scrollTop() is stopArea and clearInterval(e.intTopHandler)
        , i
      else if windowHeight - scrollArea <= pageY
        processScroll = true
        e.stopScroll()
        e.intBottomHandler = setInterval ->
          $window.scrollTop($window.scrollTop() + margin)
          $window.scrollTop() is stopArea and clearInterval(e.intBottomHandler)
        , i
      else windowHeight - scrollArea >= pageY and processScroll = false
      if !processScroll
        clearInterval e.intTopHandler
        clearInterval e.intBottomHandler
    stopScroll: ->
      self = @
      clearInterval(self.intTopHandler)
      clearInterval(self.intBottomHandler)
      return




  blockDragScroll
]



// WEBPACK FOOTER //
// ./src/app/editor/services/layout_editor/blockDragScroll.coffee